import { Color } from "@evergis/color";
import { AggregationFunction } from "@evergis/api";
import { getRandomColor } from "react-sgis/symbols/SymbolRenderer/getRandomColor";

export type Layer = {
  value?: string;
  text?: string;
  attributes?: string[];
  aggregationAttributes?: { name: string; type: string }[];
  attribute?: string;
  id?: string;
  uniqueId: number;
  selected: boolean;
  isAggregated: boolean;
  aggregateAttr: string;
  aggregateFunc: AggregationFunction | null;
  aggregationColor: Color;
};
export type LayersState = Layer[];
export const initialLayerState: LayersState = [];
export const initialRangeState = [null, null] as [Date, Date];
export const emptyDuration: Duration = { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };

export enum ActionLayerKind {
  AddLayer = "ADD_LAYER",
  AddLayers = "ADD_LAYERS",
  UpdateLayer = "UPDATE_LAYER",
  ClearLayres = "CLEAR_LAYERS",
  DeleteLayer = "DELETE_LAYER",
  ToggleLayer = "TOGGLE_LAYER",
}

type AddLayerAction = {
  type: ActionLayerKind.AddLayer;
};

type AddLayersAction = {
  type: ActionLayerKind.AddLayers;
  payload: LayersState;
};

type UpdateLayerAction = {
  type: ActionLayerKind.UpdateLayer;
  payload: { data: Layer } & { index: number };
};

type ClearLayresAction = {
  type: ActionLayerKind.ClearLayres;
};

type DeleteLayerAction = {
  type: ActionLayerKind.DeleteLayer;
  payload: number;
};

type ToggleLayerAction = {
  type: ActionLayerKind.ToggleLayer;
  payload: number;
};

export type LayerAction =
  | AddLayerAction
  | UpdateLayerAction
  | ClearLayresAction
  | DeleteLayerAction
  | ToggleLayerAction
  | AddLayersAction;

export const layerReducer = (state: LayersState, action: LayerAction): LayersState => {
  switch (action.type) {
    case ActionLayerKind.AddLayer: {
      return [
        ...state,
        {
          uniqueId: state.reduce((bigiestIndex, { uniqueId }) => Math.max(bigiestIndex, uniqueId), 0) + 1,
          selected: true,
          isAggregated: false,
          aggregateAttr: "",
          aggregateFunc: null,
          aggregationColor: new Color(getRandomColor()),
        },
      ];
    }
    case ActionLayerKind.AddLayers: {
      return [...action.payload];
    }
    case ActionLayerKind.UpdateLayer: {
      return state.map(layer =>
        layer.uniqueId === action.payload.index ? { ...layer, ...action.payload.data } : layer,
      );
    }
    case ActionLayerKind.ClearLayres: {
      return [];
    }
    case ActionLayerKind.DeleteLayer: {
      return state.filter(({ uniqueId }) => uniqueId !== action.payload);
    }
    case ActionLayerKind.ToggleLayer: {
      return state.map(layer => (layer.uniqueId === action.payload ? { ...layer, selected: !layer.selected } : layer));
    }
    default:
      return state;
  }
};
